import { Dropdown, Menu, Icon, Modal } from 'antd';
import React, { useMemo, useState } from 'react';
import ModalTitle from '../../components/shared/ModalTitle/ModalTitle';
import { useFetchUrlClustersQuery } from './service';
import DeleteUrlCluster from './DeleteUrlCluster';
import UpdateUrlCluster from './UpdateUrlCluster';
import { useNavigate } from "react-router-dom";

type Props = {
    websiteGuid: string;
    clusterGuid: string;
};

export default function UrlClusterHeaderActions({ websiteGuid, clusterGuid }: Props) {
    const navigate = useNavigate();
    const [isDropdownVisible, setIsDropdownVisible] = useState<boolean>(false);

    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
    const [isUpdateModalOpen, setIsUpdateModalOpen] = useState<boolean>(false);

    const { data: clusters } = useFetchUrlClustersQuery({ w_guid: websiteGuid });

    const cluster = useMemo(() => clusters?.find((cluster) => cluster.guid === clusterGuid), [clusterGuid, clusters]);

    const handleDeleteButtonClicked = () => {
        setIsDeleteModalOpen(true);
        setIsDropdownVisible(false);
    };

    const handleUpdateButtonClicked = () => {
        setIsUpdateModalOpen(true);
        setIsDropdownVisible(false);
    };

    return (
        <>
            <Dropdown
                visible={isDropdownVisible}
                onVisibleChange={setIsDropdownVisible}
                trigger={['click']}
                placement="bottomLeft"
                overlay={
                    <Menu>
                        <Menu.Item
                            key="update"
                            onClick={handleUpdateButtonClicked}
                        >
                            <Icon type="form" /> Update page group
                        </Menu.Item>
                        <Menu.Item
                            key="delete"
                            onClick={handleDeleteButtonClicked}
                        >
                            <Icon type="delete" /> Remove page group
                        </Menu.Item>
                    </Menu>
                }
            >
                <Icon
                    type="more"
                    style={{ cursor: 'pointer', fontSize: '28px' }}
                />
            </Dropdown>

            {cluster && (
                <>
                    <Modal
                        title={
                            <ModalTitle
                                title="Remove page group:"
                                meta={cluster.title}
                            />
                        }
                        visible={isDeleteModalOpen}
                        onCancel={() => setIsDeleteModalOpen(false)}
                        footer={null}
                        destroyOnClose={true}
                    >
                        <DeleteUrlCluster
                            websiteGuid={websiteGuid}
                            clusterGuid={clusterGuid}
                            onFinish={() => navigate(`/deep-analysis/?w_guid=${websiteGuid}`)}
                        />
                    </Modal>

                    <Modal
                        visible={isUpdateModalOpen}
                        title={
                            <ModalTitle
                                title="Update page group:"
                                meta={cluster.title}
                            />
                        }
                        footer={null}
                        onCancel={() => setIsUpdateModalOpen(false)}
                        destroyOnClose={true}
                    >
                        <UpdateUrlCluster
                            websiteGuid={websiteGuid}
                            cluster={cluster}
                            onFinish={() => setIsUpdateModalOpen(false)}
                        />
                    </Modal>
                </>
            )}
        </>
    );
}
